import {Box, Button, Form, FormField, Heading, RadioButtonGroup, Text, TextInput} from 'grommet';
import React, {useEffect, useState} from "react";
import ApiService from "../../services/ApiService";
import ErrorService from "../../services/ErrorService";
import Highcharts from 'highcharts'
import HighchartsExporting from 'highcharts/modules/exporting'
import Helpbar from "../../components/Helpbar/Helpbar";
import AuthService from "../../services/AuthService";
import ThemeService from "../../services/ThemeService";
import AnnuityHelp from "./AnnuityHelp";
import AnnuityPdfExport from "./AnnuityPdfExport";
import FormatService from "../../services/FormatService";
import CalcDetailService from "../../services/CalcDetailService";
import {UgSpinner} from "../../components/Spinner/UgSpinner";
import {UgPdfIcon} from "../../components/Icons/UgPdfIcon";
import {UgHelpIcon} from "../../components/Icons/UgHelpIcon";
import {useDispatch} from "react-redux";
import CalcPinService from "../../services/CalcPinService";
import * as Icons from "grommet-icons";
import SavedStatesService from "../../services/SavedStatesService";
import AddEditSavedStatesModal from "../SavedStates/AddEditSavedStatesModal";
import {toast} from "react-toastify";
import LoadSavedStatesModal from "../SavedStates/LoadSavedStatesModal";

function Annuity(props) {
    const calcStateKey = 'Annuity';
    const calcStateVersion = 1;

    HighchartsExporting(Highcharts);

    const defaultValues = {
        title: 'Kalkulačka renty',
        mode: 'payment',

        investment: 10000,
        period: 5,
        periodUnits: 'y',
        interestRate: 3,
        annuity: 150,

        activeRequest: false,
        openHelp: false,
        pdfGenerating: false,
    };
    const valuesInitialState = CalcDetailService.pluckInitialState(calcStateKey, 'values', defaultValues, calcStateVersion);
    const resultInitialState = CalcDetailService.pluckInitialState(calcStateKey, 'result', null, calcStateVersion);

    const [values, setValues] = useState(valuesInitialState);
    const [result, setResult] = useState(resultInitialState);

    function saveCalcDetail(values, result){
        const calcDetailState = {
            values:values,
            result:result
        };
        if (window.debug){
            console.log('Saving ', calcStateKey, );
        }
        CalcDetailService.setStateForCalc(calcStateKey, calcDetailState, calcStateVersion);
    }

    function onFormSubmit(values){

        let reqData = {};
        switch (values.mode){
            case 'payment':
                const periodMonths = values.periodUnits === 'm' ? values.period : values.period*12;
                reqData = {
                    investment: values.investment,
                    interestRate: values.interestRate,
                    period: periodMonths
                }; break;
            case 'period':
                reqData = {
                    investment: values.investment,
                    interestRate: values.interestRate,
                    annuity: values.annuity
                }; break;
            default: break;
        }

        setValues(Object.assign({}, values, {activeRequest: true}));
        ApiService.call('post', '/v2/annuity/'+values.mode, reqData)
            .then((res) => {
                    setResult(res);
                    setValues(Object.assign({}, values, {activeRequest: false}));
                    saveCalcDetail(values, res);
                },
                (error) => {
                    setValues(Object.assign({}, values, {activeRequest: false}));
                    ErrorService.fromApi(error);
                });
    }

    const pinKey = 'kalkulacka-renty';
    const dispatch = useDispatch();
    function togglePinCalc(key){
        if (CalcPinService.isCalcPinned(key)){
            CalcPinService.unpinCalc(key).then((res)=>{
                CalcPinService.setStateData(res);
                dispatch({type:'calcpin/save'});
            });
        } else {
            CalcPinService.pinCalc(key).then((res)=>{
                CalcPinService.setStateData(res);
                dispatch({type:'calcpin/save'});
            });
        }
    }

    function exportPdf(){
        setValues(Object.assign({}, values, {pdfGenerating: true}));
        const data = {
            pool: ThemeService.getTheme().pool,
            title: values.title,
            subtitle: '',
            filename: 'calc-export',
            content: AnnuityPdfExport({values:values,result:result,chart:null}),
        };
        fetch(`${process.env.REACT_APP_INTRANET_API_URL}/ugcalculator/generatePdf`,{
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + AuthService.getAccessToken()
            },
            body: data ? JSON.stringify(data) : null
        })
            .then(res => res.blob())
            .then(res => {
                const file = window.URL.createObjectURL(res);
                window.open(file, '_blank');
                setValues(Object.assign({}, values, {pdfGenerating: false}));
            })
            .catch(console.error);
    }


    const [showModal, setShowModal] = useState(false);
    function onAddEditSaveStateModalClose(res=null){
        if (res){
            setSavedState(res);
            setValues(res.contents.state);
            onFormSubmit(res.contents.state);
        }
        setShowModal(false);
    }

     const [savedState, setSavedState] = useState(null);
    const [showLoadModal, setShowLoadModal] = useState(false);
    function onLoadSaveStateModalClose(res=null){
        setShowLoadModal(false);
    }
    useEffect(() => {
        if (props && props.match && props.match.params && props.match.params.id){
            SavedStatesService.getDetail(props.match.params.id)
                .then((res) => {
                        if (!res || !res.contents || !res.contents.state){
                            setSavedState(null);
                            if (window.debug) {
                                console.log('Neviem otvoriť stav, pretože dáta sú neplatné.', savedState, calcStateVersion);
                            }
                            return false;
                        }
                        if (res.contents && res.contents.version && calcStateVersion){
                            if (res.contents.version !== calcStateVersion){
                                setSavedState(null);
                                if (window.debug) {
                                    console.log('loadSavedState', 'zla verzia ulozenych dat, neviem otvorit', res, calcStateVersion);
                                }
                                return false;
                            }
                        }
                        toast.success('Modelovanie bolo načítané', {
                            position: "top-center",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        });
                        setSavedState(res);
                        setValues(res.contents.state);
                        onFormSubmit(res.contents.state);
                    },
                    (error) => {
                        setValues(Object.assign({}, values, {activeRequest: false}));
                        ErrorService.fromApi(error);
                    });
        }
    }, [props.match.params.id]);

    return (
        <Box flex={false} margin={{'horizontal': 'small'}}>
            <Helpbar open={values.openHelp} closeaction={ () => setValues(Object.assign({}, values, {openHelp: false})) }><AnnuityHelp/></Helpbar>

            <Box pad={'small'} direction={'row-responsive'} align={'center'} justify={'between'}>
                <Heading>{values.title} <a style={{cursor:'pointer'}} onClick={()=>{togglePinCalc(pinKey)}}><Icons.Pin color={CalcPinService.isCalcPinned(pinKey) ? 'active' : 'dark'} /></a></Heading>
                <Box direction={'row'}>
                    <LoadSavedStatesModal show={showLoadModal} pinkey={pinKey} closeaction={(res)=>onLoadSaveStateModalClose(res)}>
                        <Button margin={{right:'xsmall'}} size={'small'} secondary label={<Icons.Catalog />} onClick={()=>setShowLoadModal(true)} />
                    </LoadSavedStatesModal>
                    <AddEditSavedStatesModal show={showModal}
                                             closeaction={(res)=>onAddEditSaveStateModalClose(res)}
                                             state={values}
                                             version={calcStateVersion}
                                             savedState={savedState}
                                             pinkey={pinKey}>
                        <Button margin={{right:'xsmall'}} size={'small'} secondary label={<Icons.Save />} onClick={()=>setShowModal(true)} />
                    </AddEditSavedStatesModal>
                    <Button margin={{right:'xsmall'}} size={'small'} secondary label={values.pdfGenerating ? <UgSpinner /> : <UgPdfIcon />} disabled={!result && !values.pdfGenerating} onClick={()=>{exportPdf()}} />
                    <Button margin={'none'} size={'small'} secondary label={<UgHelpIcon />} onClick={()=>{setValues(Object.assign({}, values, {openHelp: true}))}} />
                </Box>
            </Box>

           

            <Box flex={false} pad={'medium'} round={'small'} border={true} background={'white'}>
                <Form
                    value={values}
                    onChange={nextValue => {
                        if (values.mode!==nextValue.mode){
                            setResult(null);
                        }
                        setValues(nextValue);
                        saveCalcDetail(nextValue, result);
                    }}
                    onReset={() => {
                        let init = defaultValues;
                        init.mode = values.mode;
                        setValues(init);
                        setResult(null);
                        saveCalcDetail(init, null);
                    }}
                    onSubmit={({ value }) => onFormSubmit(value) }
                >

                    <Box direction={'row-responsive'}>
                        <Box basis={'auto'} round={'xsmall'} margin={{bottom: 'large', top:'medium'}}>
                            <RadioButtonGroup direction={props.size==='small'? 'column' : 'row'} gap={'medium'} name="mode" options={[
                                {value: 'payment',label: "Výška renty"},
                                {value: 'period',label: "Doba poberania renty"},
                            ]} />
                        </Box>
                    </Box>

                    { values.mode==='payment' &&
                        <Box direction={'row'} align={'center'} wrap>
                            <FormField label='Doba "rozpustenia" vkladu na účte' width={'auto'}>
                                <TextInput name="period" type="number" min="1" step="1" required={true} />
                            </FormField>
                            <RadioButtonGroup gap={'small'} margin={{left: 'small'}} width={'auto'} direction={'column'} name="periodUnits" options={[
                                {value: 'm',label: "Mesiacov"},
                                {value: 'y',label: "Rokov"},
                            ]} />
                        </Box>
                    }

                    <Box direction={'row-responsive'}>
                        { values.mode==='period' &&
                            <Box basis={'1/3'} direction={'row'} align={'center'}>
                                <FormField label="Výška mesačnej renty (€)" width={'full'}>
                                    <TextInput name="annuity" type="number" step="0.01" required={true}/>
                                </FormField>
                            </Box>
                        }

                        <Box basis={'1/3'} direction={'row'} align={'center'}>
                            <FormField label="Jednorázový vklad (€)" width={'full'}>
                                <TextInput name="investment" type="number" step="0.01" required={true} />
                            </FormField>
                        </Box>

                        <Box basis={'1/3'} direction={'row'} align={'center'}>
                            <FormField label="Očakávaný ročný výnos (%)" width={'full'}>
                                <TextInput name="interestRate" type="number" step="0.01" required={true} />
                            </FormField>
                        </Box>

                    </Box>

                    <Box direction="row" gap="medium" margin={{top:'medium'}}>
                        <Button type="submit" primary label="Vypočítať" disabled={values.activeRequest} />
                        <Button type="reset" label="Nastaviť predvolené" />
                    </Box>
                </Form>
            </Box>


            {result &&
            <Box direction={props.size==='small'? 'column' : 'row'} pad={'xsmall'} margin={{vertical: 'medium'}} border={true} round={'small'} background={'light-2'} align={'center'} alignContent={'between'}>
                <Box pad="small" alignContent={'between'} basis={'3/4'}>
                    {values.mode === 'payment' && <Text>Výška mesačnej renty</Text>}
                    {values.mode === 'period' && <Text>Doba "rozpustenia" vkladu na účte</Text>}
                </Box>
                <Box pad="small" align={'end'} basis={'1/4'}>
                    <Heading level={2} fill={true} margin={'none'}>
                        {values.mode === 'payment' && <span><strong>{FormatService.round(result.annuity)} €</strong></span>}
                        {values.mode === 'period' && <span><strong>{result.period} {FormatService.pluralify(result.period, 'mesiac', 'mesiace', 'mesiacov')}</strong></span>}
                    </Heading>
                </Box>
            </Box>
            }

        </Box>
    );
}

export default Annuity;